var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tag",
    _vm._b(
      {
        staticClass: "column-tag-renderer",
        attrs: { effect: "dark", size: "small" }
      },
      "el-tag",
      _vm.tagProps,
      false
    ),
    [_vm._v(_vm._s(_vm.params.value))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }